const parseTime = (time: string): { hours: number; minutes: number } | null => {
  if (!time) return null;
  const [hoursStr, minutesStr] = time.split(':');
  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  return { hours, minutes };
};

export const localTimeToUTC = (time: string): string => {
  const parsed = parseTime(time);
  if (!parsed) return time;
  const date = new Date();
  date.setHours(parsed.hours, parsed.minutes, 0, 0);
  const hh = String(date.getUTCHours()).padStart(2, '0');
  const mm = String(date.getUTCMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
};

export const utcTimeToLocal = (time: string): string => {
  const parsed = parseTime(time);
  if (!parsed) return time;
  const date = new Date();
  date.setUTCHours(parsed.hours, parsed.minutes, 0, 0);
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
};

export const formatTimeTo12Hour = (time: string): string => {
  const parsed = parseTime(time);
  if (!parsed) return time;
  const period = parsed.hours >= 12 ? 'PM' : 'AM';
  const hours12 = parsed.hours % 12 || 12;
  const mm = String(parsed.minutes).padStart(2, '0');
  return `${hours12}:${mm} ${period}`;
};

export const formatUTCDateTimeToLocal = (dateStr: string): string => {
  const hasTimezone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(dateStr);
  const normalized = hasTimezone ? dateStr : `${dateStr}Z`;
  return new Date(normalized).toLocaleString();
};
